import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.

function Animations() {

  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" >every pixel deserves to shift</h1>
            <p className="banner-description">
              Bring your ideas to life with our custom animation services, including 2D, 3D, and motion graphics for engaging visual storytelling.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Main Services Thumbnail.png" // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>

      {/* Animation Styles Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Custom Animation Styles</strong></h2>
            <p>We create a variety of animation styles to suit your branding and marketing needs.</p>
            <ul>
              <p><strong>2D Animation:</strong> Bring your ideas to life with dynamic and colorful 2D visuals.</p>
              <p><strong>3D Animation:</strong> Create realistic and immersive 3D models and animations.</p>
              <p><strong>Motion Graphics:</strong> Convey complex information through animated graphics.</p>
              <p><strong>Hand-Drawn Animation:</strong> Add a personal touch with beautifully crafted hand-drawn animations.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m6.1.png" alt="Custom Animation" />
          </div>
        </div>

        {/* Animation Process Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Animation Production Process</strong></h2>
            <p>Our comprehensive animation process ensures high-quality results that capture your brand’s vision and engage your audience.</p>
            <ul>
              <p><strong>Scripting & Storyboarding:</strong> Define the narrative and structure.</p>
              <p><strong>Design & Animation:</strong> Create visually captivating designs and bring them to life.</p>
              <p><strong>Post-Production:</strong> Final editing and effects to perfect the animation.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m6.2.png" alt="Animation Process" />
          </div>
        </div>

        {/* Animation Portfolio Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Animation Portfolio</strong></h2>
            <p>Explore how we have helped businesses and brands tell their stories through stunning animations.</p>
            <a href="/blog" className="cta-button">Browse Portfolio</a>
          </div>
          <div className="about-image">
            <img src="/img/m6.3.png" alt="Animation Portfolio" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default Animations;
